'use strict'
import axios from 'axios'
import Vue from 'vue'
import { reqThen, reqCatch, resThen, resCatch } from './interceptors'
const config = require("../../config.js");
let base_url = config.getCen();
// let base_url = 'sdata/rest/service/dataapi/rest';
Vue.prototype.$filebase_url = config.getImgBaseUrl();

const service = axios.create({
    timeout: 100000,
    baseURL: base_url
})
const uplodService = axios.create({
        timeout: 100000,
        // baseURL: base_url + '/api'
    })
    //这个是设置请求拦截器的api，传入两个回调，第一个成功回调，第二个失败回调。
service.interceptors.request.use(reqThen, reqCatch)
    //这个是设置响应拦截器的api，第一个成功回调，第二个失败回调
service.interceptors.response.use(resThen, resCatch)

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
function post(url, params) {
    return new Promise((resolve, reject) => {
        if (url.substr(0, 1) != "/") {
            url = '/' + url
        }
        service.post(url, params).then(res => {
                resolve(res.result)
            })
            .catch(err => {
                reject(err)
            })
    });
}

/**
 * 上传文件对应post请求
 */
function filePost(url, params) {
    return new Promise((resolve, reject) => {
        uplodService.post(
                url, params, {
                    headers: {
                        'token': localStorage.getItem("token"),
                    }
                },
            ).then(res => {
                return resolve(res.data.data);
            })
            .catch(err => {
                reject(err);
            })
    });
}

Vue.prototype.$post = post;
Vue.prototype.$filePost = filePost;


export default {
    request: config =>
        service
        .request(config)
        .then(result => {
            if (config.myJson) {
                return result.data
            } else if (result.status === 200) {
                return result.data.data
            } else {
                return {}
            }
        })
        .catch(error => {
            let returnErr
            if (error && typeof error === 'object') {
                returnErr = error.response.data
            } else {
                returnErr = error
            }
            return Promise.reject(returnErr)
        })
}